import { render, staticRenderFns } from "./sale-control.vue?vue&type=template&id=66fa6f08&"
import script from "./sale-control.vue?vue&type=script&lang=js&"
export * from "./sale-control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports